import styled from '@emotion/styled';
import { TableCell, TableRow } from '@mui/material';

import type { ZuubPatientListItemV3 } from '../../../@types/zuub/contracts';
import { type Appointment } from '../../../react-query/useAppointments';
import type { Task } from '../../../react-query/useGetTasks';
import type { TVisitSummary } from '../../../react-query/useVisitSummaries';

import { PatientCell } from './patientCell';
import { RecommendationsCell } from './recommendationsCell';
import { TreatmentsCell } from './treatmentsCell';

const StyledTableRow = styled(TableRow)`
  break-inside: avoid;
  vertical-align: top;

  #findings {
    .findings-container {
      display: flex;
      flex-direction: column;
      gap: 0.5em;
    }

    .incipient {
      display: flex;
      .incipient-text.MuiTypography-root {
        font-size: 1em;
        font-weight: 600;
        margin-right: 0.5em;
      }
    }
    .findings-perio-and-calculus {
      display: flex;
      gap: 1em;
    }
    .analysis-date.MuiTypography-root {
      font-size: 1em;
    }
    .quadrants {
      display: grid;
      grid-template-columns: 1fr 1fr;
      max-width: 3.25em;
    }
  }
`;

interface Props {
  appointment: Appointment;
  isLoadingTreatments: boolean;
  tasks: Task[];
  visitSummary?: TVisitSummary;
  zuubInsurance?: ZuubPatientListItemV3;
}

export const HuddlePrintoutAppointment = ({
  appointment,
  isLoadingTreatments,
  tasks,
  visitSummary,
  zuubInsurance,
}: Props) => {
  return (
    <StyledTableRow data-testid="huddle-printout-appointment">
      <TableCell data-testid="patient-cell" id="patient">
        <PatientCell appointment={appointment} zuubInsurance={zuubInsurance} />
      </TableCell>

      <TableCell id="treatments">
        <TreatmentsCell
          loading={isLoadingTreatments}
          visitSummary={visitSummary}
        />
      </TableCell>

      <TableCell>
        <RecommendationsCell
          appointment={appointment}
          tasks={tasks}
          visitSummary={visitSummary}
        />
      </TableCell>
    </StyledTableRow>
  );
};
